import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/helpers/date-formats';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import * as moment from 'moment';
import { StatsService } from 'src/app/core/services/stats.service';
import { ToastrService } from 'ngx-toastr';
import { ValidadoresService } from '../../../../core/services/validadores.service';

registerLocaleData(localeEs, 'es-ES', localeEsExtra);

@Component({
  selector: 'app-docs-secun-tercero',
  templateUrl: './docs-secun-tercero.component.html',
  styleUrls: ['./docs-secun-tercero.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class DocsSecunTerceroComponent implements OnInit {

  loading: boolean;
  mostrarListado: boolean;
  mostrarError: boolean;
  filtro: FormGroup;
  datos = [];

  constructor(
    private statsService: StatsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private validadores: ValidadoresService
  ) {

    this.loading = false;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.datos = [];
  }

  ngOnInit() {

    this.filtro = this.fb.group({
      fechaInicial: ['', [this.validadores.fechaNoAdecuada]],
      fechaFinal: ['', [this.validadores.fechaNoAdecuada]]
    });
  }

  VisualizarDatos(fechaInicial: string, fechaFinal: string) {

    this.loading = true;
    this.mostrarError = false;
    this.mostrarListado = false;
    this.datos = [];

    this.statsService.ObtenerListadoSecunTercerosTotal(this.GetFechaInteger(fechaInicial), this.GetFechaInteger(fechaFinal)).subscribe(datos => {

      this.loading = false;
      this.datos = datos;
      console.log("Listado: ");
      console.log(this.datos);
      this.mostrarListado = true;

    }, (error) => {
      this.toastr.error("Error al cargar los resultados");
      console.log(error);
      this.loading = false;
      this.mostrarError = true;
    });
  }

  fechaChange($event, esFecha: number) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    if (esFecha == 1) {

      this.filtro.patchValue({
        fechaInicial: resultado
      });
    }
    if (esFecha == 2) {

      this.filtro.patchValue({
        fechaFinal: resultado
      });
    }
  }

  private GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

  private SetFechaString(date: number): string {
    let resultado: string = "";

    if (Number.isNaN(date) == true || date == undefined || date == null) {
      return "";
    }

    if (date == 0) {
      return "";
    }

    let dia: number = 0;
    let mes: number = 0;
    let ano: number = 0;

    ano = this.redondearExp(date / 10000, 0);
    date = date - (ano * 10000);
    mes = this.redondearExp(date / 100, 0);
    dia = date - (mes * 100);

    if (ano == 0 || mes == 0 || dia == 0) {
      return "";
    }

    resultado = dia.toString().padStart(2, "0") + "/" + mes.toString().padStart(2, "0") + "/" + ano.toString();

    return resultado;
  }

  private toExp(numero: Number, digitos: number): number {
    let arr = numero.toString().split("e");
    let mantisa = arr[0], exponente = digitos;
    if (arr[1]) exponente = Number(arr[1]) + digitos;
    return Number(mantisa + "e" + exponente.toString());
  }

  private redondearExp(numero: number, digitos: number, masEspaciado: boolean = false): number {

    let absNumero = Math.abs(numero);
    let signo = Math.sign(numero);

    if (masEspaciado) {
      let n = Math.floor(Math.log2(absNumero));
      let spacing = Math.pow(2, n) * Number.EPSILON;
      if (spacing < Math.pow(10, -digitos - 1)) {
        absNumero += spacing;
      }
    }

    let entero = Math.round(this.toExp(absNumero, digitos));
    return signo * this.toExp(entero, -digitos);
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  private isDecimal(numero) {
    if (typeof numero === 'undefined') {
      return false;
    } else {
      numero = Math.abs(numero);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(numero)) {
      return true;
    }
    else {
      return false;
    }
  }

  convertThousandsFixed(number: any, digits) {

    if (typeof number === 'undefined') {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(2);

      number = number.toString().replace('.', ',');
    }

    var value = number.toString().split('.').join('');
    var numbers = value.split(',');
    var enter = numbers[0];
    var new_number = '';

    var amount = enter.toString();
    amount = amount.split('').reverse();
    var output = '';
    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && (amount.length - 1) !== i) output = '.' + output;
    }

    if (digits !== '0') {

      if (numbers.length === 1) {
        if (numbers[0] === '') {
          new_number = output;
        } else {
          new_number = output + ',00';
        }
      } else {
        if (numbers[1] === '') {
          new_number = output + ',00';
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + ',' + numbers[1].substring(0, 1) + '0';
          } else {
            new_number = output + ',' + numbers[1].substring(0, digits);
          }
        }
      }
      if (new_number.substring(0, 1) === '-' && new_number.substring(1, 2) === '.') {
        new_number = new_number.replace('.', '');
      }
      if (new_number === '0,0000') {
        new_number = '0,00';
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + ',' + numbers[1];
      }
    }

    if (digits === '0') {
      numbers = new_number.split(',');
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }

}
